import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "../../assets/css/Navigation.css";
import ViewAll from "./ViewAll";
import CartWishlist from "./component/CartWishlist";
import DropDownProfile from "./component/DropDownProfile";
import AddtoCart from "./component/CartCount";
// import ComingsoonCart from "./component/CartCountComingsoon";
import { getMenuService } from "./service/MenuService";
import { getProductUrl } from "../../utils/url.utils";
import logowhite from "../../assets/images/white-logo.png"
import GlobalSearch from "./component/GlobalSearch";

const Navigationbar = () => {
  const location = useLocation();
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [activeSearch, setActiveSearch] = useState(null);
  const [searchText, setSearchText] = useState({});
  const [megaMenu, setMegaMenu] = useState([]);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  const handleSearchChange = (slug, value) => {
    setSearchText((prev) => ({
      ...prev,
      [slug]: value,
    }));
  };

  useEffect(() => {
    loadMenu();
  }, []);

  const loadMenu = async () => {
    try {
      const cachedMenu = localStorage.getItem("megaMenu");

      if (cachedMenu) {
        setMegaMenu(JSON.parse(cachedMenu));
      }

      const menu = await getMenuService();

      if (menu && menu.length > 0) {
        setMegaMenu(menu);

        localStorage.setItem(
          "megaMenu",
          JSON.stringify(menu)
        );
      }
    } catch (error) {
      console.error("Menu loading error:", error);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (activeSearch && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [activeSearch]);

  const closeMenu = () => {
    setShowDropdown(false);
    setActiveSubmenu(null);
    setActiveSearch(null);
    setSearchText({});
  };

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  const handleSubmenuClick = (e, sub) => {
    e.preventDefault();
    e.stopPropagation();

    if (!sub.qualities || sub.qualities.length === 0) {
      return;
    }

    const slug = sub.subcategory_slug;

    if (isMobile) {
      setActiveSubmenu((prev) => {
        if (prev === slug) {
          setActiveSearch(null);
          return null;
        }

        setActiveSearch(slug);
        return slug;
      });

      return;
    }

    setActiveSubmenu(slug);
    setActiveSearch(slug);
  };

  const handleSubmenuMouseEnter = (sub) => {
    if (isMobile) {
      return;
    }

    if (sub.qualities?.length > 0) {
      setActiveSubmenu(sub.subcategory_slug);
      setActiveSearch(sub.subcategory_slug);
    }
  };

  return (
    <>
      <Navbar expand="lg" className="bg-Dark">
        <Container className="Mobile-disable-menu">
          

          <Navbar.Brand className="navbar-brand-box">
            <Link to="/home">
              <img
                src={logowhite}
                className="logo-Responsive-Obsessions"
                alt="Logo"
              />
            </Link>
          </Navbar.Brand>

          {isMobile ? (
            <div
              className="hamburger"
              onClick={() => setMenuOpen((prev) => !prev)}
            >
              &#9776;
            </div>
          ) : (

            <Nav className="ms-right desktop-menu">

              {megaMenu.map((category) => (

                <NavDropdown
                  key={category.category_slug}
                  title={category.category_name}
                  id={category.category_slug}
                  show={
                    showDropdown === category.category_slug
                  }
                  onMouseEnter={() => {
                    setShowDropdown(
                      category.category_slug
                    );
                  }}
                  onMouseLeave={() => {
                    if (!isMobile) {
                      setShowDropdown(false);
                      setActiveSubmenu(null);
                      setActiveSearch(null);
                    }
                  }}
                  onClick={(e) => {
                    if (!isMobile) {
                      e.preventDefault();
                    }
                  }}
                >

                  {category.subcategories
                    ?.filter(
                      (sub) => sub.subcategory_name
                    )
                    .map((sub, subIndex) => {

                      const isSubmenuOpen =
                        activeSubmenu ===
                        sub.subcategory_slug;

                      return (
                        <div
                          className="dropdown-submenu"
                          key={`${sub.subcategory_slug}-${subIndex}`}
                        >

                          <NavDropdown.Item
                            className="submenu-toggle"
                            onClick={(e) =>
                              handleSubmenuClick(e, sub)
                            }
                            onMouseEnter={() =>
                              handleSubmenuMouseEnter(sub)
                            }
                          >

                            {sub.subcategory_name}

                            {sub.qualities?.length > 0 && (
                              <span className="RightArrow">
                                <i className="bi bi-chevron-right"></i>
                              </span>
                            )}

                          </NavDropdown.Item>

                          {sub.qualities?.length > 0 &&
                            isSubmenuOpen && (

                              <>
                                {sub.qualities.length > 8 ? (

                                  <div className="submenu widthIncrese">

                                    <div className="searchboxNav">

                                      <input
                                        ref={
                                          activeSearch ===
                                          sub.subcategory_slug
                                            ? searchInputRef
                                            : null
                                        }
                                        autoFocus={
                                          activeSearch ===
                                          sub.subcategory_slug
                                        }
                                        type="text"
                                        placeholder="Search"
                                        className="searchinput"
                                        value={
                                          searchText[
                                            sub.subcategory_slug
                                          ] || ""
                                        }
                                        onChange={(e) =>
                                          handleSearchChange(
                                            sub.subcategory_slug,
                                            e.target.value
                                          )
                                        }
                                      />

                                      <span className="searchicons">
                                        <i className="bi bi-search"></i>
                                      </span>

                                    </div>

                                    {(() => {

                                      const filteredQualities =
                                        sub.qualities.filter(
                                          (quality) =>
                                            quality.quality_name
                                              ?.toLowerCase()
                                              .includes(
                                                (
                                                  searchText[
                                                    sub.subcategory_slug
                                                  ] || ""
                                                ).toLowerCase()
                                              )
                                        );

                                      const menuQualities =
                                        filteredQualities.slice(
                                          0,
                                          30
                                        );

                                      const itemsPerColumn = 10;

                                      const columns =
                                        Math.ceil(
                                          menuQualities.length /
                                            itemsPerColumn
                                        );

                                      return (

                                        <div className="row">

                                          {Array.from(
                                            {
                                              length: columns,
                                            },
                                            (_, index) => (

                                              <div
                                                key={index}
                                                className={`col-md-${Math.max(
                                                  3,
                                                  Math.floor(
                                                    12 / columns
                                                  )
                                                )}`}
                                              >

                                                {menuQualities
                                                  .slice(
                                                    index *
                                                      itemsPerColumn,
                                                    (index + 1) *
                                                      itemsPerColumn
                                                  )
                                                  .map(
                                                    (
                                                      quality,
                                                      qualityIndex
                                                    ) => (

                                                      <NavDropdown.Item
                                                        key={`${sub.subcategory_slug}-${quality.quality_action_link}-${qualityIndex}`}
                                                        as={Link}
                                                        onClick={
                                                          closeMenu
                                                        }
                                                        to={getProductUrl(
                                                          quality.quality_action_link
                                                        )}
                                                        style={{
                                                          color: "#fff",
                                                          whiteSpace:
                                                            "normal",
                                                          wordBreak:
                                                            "break-word",
                                                        }}
                                                      >
                                                        {
                                                          quality.quality_name
                                                        }
                                                      </NavDropdown.Item>

                                                    )
                                                  )}

                                              </div>

                                            )
                                          )}

                                          {filteredQualities.length >
                                            24 && (

                                            <div className="col-12 text-end">

                                              <ViewAll
                                                data={
                                                  filteredQualities
                                                }
                                              />

                                            </div>

                                          )}

                                        </div>

                                      );

                                    })()}

                                  </div>

                                ) : (

                                  <div className="submenu">

                                    {sub.qualities.map(
                                      (
                                        quality,
                                        qualityIndex
                                      ) => (

                                        <NavDropdown.Item
                                          key={`${sub.subcategory_slug}-${quality.quality_action_link}-${qualityIndex}`}
                                          as={Link}
                                          onClick={
                                            closeMenu
                                          }
                                          to={getProductUrl(
                                            quality.quality_action_link
                                          )}
                                        >

                                          {
                                            quality.quality_name
                                          }

                                        </NavDropdown.Item>

                                      )
                                    )}

                                  </div>
                                )}
                              </>
                            )}
                        </div>
                      );
                    })}
                </NavDropdown>
              ))}
            </Nav>
           )}

          <Navbar.Brand className="navbar-brand-topmenu">
            <div className="Wishlist-with-login d-none-mobile">
              <GlobalSearch />
              <CartWishlist />
              <AddtoCart />
              {/* <ComingsoonCart /> */}
              <DropDownProfile
                dropdownRef={dropdownRef}
                handleMouseEnter={() =>
                  setShowProfileDropdown(true)
                }
                handleMouseLeave={() =>
                  setShowProfileDropdown(false)
                }
                handleClick={() =>
                  setShowProfileDropdown(
                    (prev) => !prev
                  )
                }
                showDropdown={
                  showProfileDropdown
                }
                Link={Link}
                userData={
                  localStorage.getItem("user") || ""
                }
              />
            </div>
          </Navbar.Brand>

          
        </Container>
      </Navbar>
    </>
  );
};
export default Navigationbar;